import {
  CinchChargeFormSuccess,
  CinchChargeRequestForm,
} from '@in-life-and-loyalty/vaps-ui'
import { useState } from 'react'

import styles from './feature-cinchcharge-request.module.css'

const FeatureCardRequest: React.FC = () => {
  const [showSuccessScreen, setShowSuccessScreen] = useState<boolean>(false)

  return (
    <div className={styles.mainSection}>
      {!showSuccessScreen ? (
        <CinchChargeRequestForm setShowSuccessScreen={setShowSuccessScreen} />
      ) : (
        <CinchChargeFormSuccess />
      )}
    </div>
  )
}

export default FeatureCardRequest
